module.exports = __webpack_public_path__ + "static/media/road-straight.1d7c00cb.svg";